var map = {
	"./account.svg": "ef22",
	"./arrow-down.svg": "1033",
	"./case.svg": "68f6",
	"./close.svg": "7710",
	"./company.svg": "9ef7",
	"./delete.svg": "59a1",
	"./edit.svg": "aa46",
	"./help.svg": "c932",
	"./keyword.svg": "5bcb",
	"./lock.svg": "ab00",
	"./menu.svg": "bd3d",
	"./more.svg": "3dd0",
	"./no-data.svg": "9181",
	"./page-config.svg": "f9b8",
	"./personal.svg": "ce9e",
	"./product.svg": "8d30",
	"./success.svg": "a8cf",
	"./topic.svg": "5c23",
	"./traffic.svg": "d115",
	"./user.svg": "b3b5",
	"./warning.svg": "7e6f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";